import { MONITOR_ALL_COMPANIES_LOAD, MONITOR_UNLOAD, MONITOR_ALL_LIST } from "../../actions/Constants";

const INITIAL_STATE = { allCompanies: [], monitoramentos: [] };

export default function monitoramento(state = INITIAL_STATE, action) {
  switch (action.type) {
    case MONITOR_ALL_COMPANIES_LOAD:
      return {
        ...state,
        allCompanies: action.payload ? action.payload : null,
      };
    case MONITOR_ALL_LIST:
      return {
        ...state,
        monitoramentos: action.payload ? action.payload : null,
      };
    case MONITOR_UNLOAD:
      return INITIAL_STATE;
    default:
      return state;
  }
}
